import React, { Fragment } from "react";
import Footer from "../../Shear/Footer/Footer";
import Header from "../../Shear/Header/Header";
import { Link } from "react-router-dom";
import { courses } from "../../../Data/courses";
import Head from "../../../layout/Head";
import css from "../../../Assets/Styles/course.module.css";
import { Fade } from "react-reveal";
import ScrollToTop from "../../Shear/ScrollToTop";

const Course = () => {
  return (
    <Fragment>
      <Head
        Title="Our Courses"
        href="/course"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Course Pages"
      />
      <Header />
      <section className="pb-10 font-roboto pt-20 px-3 max-md:px-20 max-lg:px-0 max-lg:max-w-[1000px] max-xl:max-w-[1322px] mx-auto">
        <div className="text-center mb-[60px]">
          <button className="custom_button2 mx-auto">
            <span>~ Our Courses ~</span>
          </button>
          <h2 className="  mb-[28px] leading-[38px]  max-sm:leading-[1.1428] text-[#0D1C37] font-fira font-bold text-[25px] max-sm:text-[42px]">
            List of Our Courses
          </h2>
        </div>
        <Fade bottom>
          <div className="grid max-md:grid-cols-2 max-lg:grid-cols-3 gap-10 pb-10">
            {courses.map((data, index) => (
              <div
                className={`bg-[#fff] border border-[#ececf9] cursor-pointer rounded overflow-hidden ${css.course_card}`}
                style={{ boxShadow: "0 0 21px rgb(1 1 72 / 6%)" }}
                key={index}
              >
                <article>
                  <Link to={`/course/${data.slug}`}>
                    <img
                      src={data.images.img}
                      className="w-full"
                      alt="IT Ghar courses"
                    />
                  </Link>
                  <div className="px-5 py-8 ">
                    <h3 className="text-[#0D1C37] text-[22px] font-semibold font-fira ">
                      {data.title}
                    </h3>
                  </div>
                  <hr className="border-[#D9D9D9]" />
                  <div className="flex justify-between px-2 py-7">
                    <div className="flex gap-4 justify-center items-center">
                      <h5 className="text-[#0D1C37] text-lg font-fira font-semibold">
                        ৳{data.price.price}
                      </h5>
                      <del className="text-[#646464] text-lg font-fira font-semibold">
                        ৳ {data.price.originalPrice}
                      </del>
                    </div>
                    <Link to={`/course/${data.slug}`}>
                      <button
                        className="custom_button "
                        style={{
                          borderRadius: 0,
                          padding: " 0px 20px 0px 20px",
                          lineHeight: "46px",
                          boxShadow: "none",
                        }}
                      >
                        {" "}
                        Enroll Now
                        <i className="fa-solid fa-arrow-right ml-2"></i>
                      </button>
                    </Link>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </Fade>
      </section>
      <ScrollToTop />
      <Footer />
    </Fragment>
  );
};

export default Course;
